import styled, { css } from "styled-components";

import { Option } from "../../../public/simsFilter";

const baseStyle = css`
  box-shadow: 0px 2px 5px 2px rgba(62, 165, 219, 0.3);
  border-radius: 6px;
  min-height: 46px;
`;

const baseFontStyle = css`
  font-size: var(--font-size-sm);
  color: var(--blue-color-dark);
`;

export const InfoContainer = styled("div")`
  padding: 2.5rem 1.5rem 10rem;
  @media screen and (max-width: 768px) {
    padding: 0 15px 10rem;
  }
  button {
    @media screen and (max-width: 768px) {
      font-weight: 500;
      font-size: var(--font-size-lg);
    }
  }
  .btn-link {
    font-size: var(--font-size-lg);
  }
`;

export const ImageContainer = styled("div")`
  display: flex;
  justify-content: center;
`;

export const ImageProvider = styled("label")`
  border-radius: var(--border-radius-rounded);
  display: inline-block;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  width: 160px;
  height: 160px;
  background: var(--button-color-labs);
  box-shadow: var(--box-shadow2);
  border: 3px solid var(--white-color);
  @media screen and (max-width: 768px) {
    width: 100px;
    height: 100px;
  }

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  input {
    display: none;
  }
  span {
    position: absolute;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    transition: background-color ease 0.3s;
  }
  .edit-icon {
    visibility: hidden;
    transition: all 0.3s ease;
  }
  &:hover {
    span {
      visibility: visible;
      background: rgba(0, 0, 0, 0.3);
    }
    .edit-icon {
      visibility: visible;
    }
  }
`;

export const FormContainer = styled("form")`
  label {
    margin: 0 10px 5px 0;
    font-size: var(--font-size-sm);
    color: var(--text-color-dark);
    @media screen and (max-width: 768px) {
      font-size: var(--font-size-xs);
    }
  }
  .input {
    border: 1px solid var(--primary-color);
    ${baseStyle}
    input {
      ${baseFontStyle}
    }
  }
  .select {
    [class$="control"] {
      ${baseStyle}
      ${baseFontStyle}
    }
    [class$="singleValue"],
    [class$="placeholder"],
    [class$="option"] {
      ${baseFontStyle}
    }
    [class$="IndicatorsContainer"] {
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }
    [class$="menu"] {
      width: 148px;
    }
  }
  .disabled {
    [class$="control"] {
      opacity: 0.7;
    }
    [class$="IndicatorsContainer"] {
      display: none;
    }
  }
  .wide-menu {
    [class$="menu"] {
      width: 90%;
    }
  }
  .invalid-input {
    border: 1px solid var(--danger-color);
    border-radius: 6px;
  }
  .error-message {
    color: var(--danger-color);
    font-weight: 300;
    font-size: 10px;
    color: var(--danger-color);
    position: absolute;
  }
`;

export const StyledOption = styled(Option)`
  input[type="checkbox"] {
    display: none;
  }
`;
